import { forwardRef, type Ref, type SVGProps } from "react";

function SvgUser(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2 14v-1.029c0-1.514 1.102-2.742 3.385-2.742h6.154c1.359 0 2.461 1.228 2.461 2.742V14m-3.077-9c0 2-1.309 3-2.923 3S5.077 6.799 5.077 5 6.386 2 8 2s2.923 1.201 2.923 3"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgUser);
export default ForwardRef;
